import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import loader from "../../assets/Images/loader.gif";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import "moment/locale/fr";


const optionLeadChannel = [
  { label: "Select Channel", value: "" },
  { label: "Call/SMS-Inbound", value: "Call/SMS-Inbound" },
  { label: "Caretel", value: "Caretel" },
  { label: "CM Outbound", value: "CM Outbound" },
  { label: "Email/Email Campaigns", value: "Email/Email Campaigns" },
  { label: "Inside Sales", value: "Inside Sales" },
  { label: "Inside Sales-QC", value: "Inside Sales-QC" },
  { label: "FFA APP", value: "FFA APP" },
  { label: "NetOps Channel", value: "NetOps Channel" },
  { label: "Online CAF", value: "Online CAF" },
  { label: "Outbound Call", value: "Outbound Call" },
  { label: "Paid Campaign/Activity", value: "Paid Campaign/Activity" },
  {
    label: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
    value: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
  },
  { label: "Self Care Portal", value: "Self Care Portal" },
  { label: "Self Lead", value: "Self Lead" },
  { label: "Unify Churned", value: "Unify Churned" },
  { label: "Web Campaign", value: "Web Campaign" },
];

const BroadbandContactsManageForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeForm, setActiveForm] = useState("form1");


  const [selectLeadSource, setSelectLeadSource] = useState();
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [selectLeadChannel, setSelectLeadChannel] = useState(
    optionLeadChannel[0]
  );
  const [firstName, setFirstName] = useState("");
  const [fullName, setFullName] = useState("");
  const [lastName, setLastName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [apiSourceData, setApiSourceData] = useState([]);
  const [apiCompetitorData, setApiCompetitorData] = useState([]);
  const [selectSource, setSelectSource] = useState("");
  const [selectPlanCategory, setSelectPlanCategory] = useState("");
  const [selectStatus, setSelectStatus] = useState("");
  const [flag, setflag] = useState();
  const [selectDateTime, setSelectDateTime] = useState();
  const [selectCompetitorName, setSelectCompetitorName] = useState("");
  const [selectState, setSelectState] = useState("");
  const [selectCity, setSelectCity] = useState("");
  const [selectArea, setSelectArea] = useState("");
  const [selectSociety, setSelectSociety] = useState("");
  const [apiStateCode, setApiStateCode] = useState("");
  const [apiCityCode, setApiCityCode] = useState("");
  const [apiAreaCode, setApiAreaCode] = useState("");
  const [mobileNo, setmobileNo] = useState("");
  const [email, setEmail] = useState("");
  const [alternateNo, setalternateNo] = useState("");
  const [otpvalue, setOtpValue] = useState();
  const [resendotp, setResendOtp] = useState(false);
  const [inputOtp, setInputOtp] = useState();
  const [OTPContactStatus, setOTPContactStatus] = useState();
  const [optionState, setOptionState] = useState([]);
  const [optionCity, setOptionCity] = useState([]);
  const [optionArea, setOptionArea] = useState([]);
  const [optionSociety, setOptionSociety] = useState([]);
  const [previousSelectedState, setPreviousSelectedState] = useState(null);
  const [specifyLeadSource , setSpecifyLeadSource]= useState("");


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const leadId = searchParams.get("LeadId");
  const ContactId = searchParams.get("ContactId");
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
  const handleFirst = (e) => {
    const set = e.target.value;
    setFirstName(set);
  };

  const handleFullName = (e) => {
    const set = e.target.value;
    setFullName(set);
  };
  const handleLast = (e) => {
    const set = e.target.value;
    setLastName(set);
  };
  const handleRemark = (e) => {
    const set = e.target.value;
    setRemarks(set);
  };

  const handleSpecifyLeadSource = (e) => {
    const set = e.target.value;
    setSpecifyLeadSource(set);
  };

  const handleSelectChannel = (selectLead) => {
    setSelectLeadChannel(selectLead);
  };

  const handleSelectLeadSource = (selectLeadSource) => {
    setSelectLeadSource(selectLeadSource);
  };

  // Source
  const handleSelectSource = (selectedOption) => {
    // Check if selection and selection.value are defined
    if (selectedOption) {
      // console.log("select", selectedOption);
      setSelectSource(selectedOption);
    }
  };

    useEffect(() => {
      const fetchData = async () => {
        try {
          // lead source API call
          const leadSourceApiUrl = process.env.REACT_APP_API_URL;
          const leadSourceRequestBody = {
            Action: "getSource",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            channelName: selectLeadChannel.value,
            password: sessionStorage.getItem("password"),
            userName: sessionStorage.getItem("userName"),
          };
          const leadSourceResponse = await fetch(leadSourceApiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(leadSourceRequestBody),
          });
          const leadSourceData = await leadSourceResponse.json();
          // console.log("lead Source :", leadSourceData.Response.Data);
          // Check if data is not undefined or null before mapping
          if (leadSourceData.Response.Data) {
            // Transforming data into the required format
            const transformedOptions = leadSourceData.Response.Data.map(
              (option) => ({
                label: option.SourceName,
                value: option.SourceName,
              })
            );
            // console.log("setLeadSourceOptions",transformedOptions)
            setLeadSourceOptions(transformedOptions);
            if (!ContactId && transformedOptions.length > 0) {
              setSelectLeadSource(transformedOptions[0]);
            }
          } else {
            // If data is undefined or null, set leadSourceOptions to an empty array
            setLeadSourceOptions([]);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }, [selectLeadChannel, ContactId]);

  // useEffect(() => {
  //   const fetchSource = async () => {
  //     try {
  //       const apiurl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //         Action: "getSource",
  //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         channelName: "FFA",
  //         password: sessionStorage.getItem("password"),
  //         userName: sessionStorage.getItem("userName"),
  //       };

  //       const response = await fetch(apiurl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });

  //       const data = await response.json();
  //       console.log("SourceDATA", data);
  //       setApiSourceData(data?.Response?.Data); // Assuming responseData contains the state data
  //     } catch (error) {
  //       // console.error('Error fetching source:', error);
  //       // Handle errors
  //     }
  //   };

  //   fetchSource();
  // }, []);

  // END





  // Plan Category
  const optionPlanCategory = [
    { value: "Select Option", label: "Select Option" },
    { value: "BBB", label: "BBB" },
    { value: "OBB", label: "OBB" },
  ];
  const handleSelectPlanCategory = (selection) => {
    // console.log("selection", selection);
    const selected = selection;
    setSelectPlanCategory(selected);
  };

  // END

  // Status Reason
  const optionStatusReason = [
    { value: "0", label: "Select Option" },
    { value: "111260001", label: "Closed" },
    { value: "111260000", label: "Scheduled for Appointment" },
    { value: "111260002", label: "Lead Created/Closed" },
  ];
  const handleSelectStatus = (selection) => {
    const selected = selection;
    // console.log("selection", selection);

    setSelectStatus(selected);
    if (selected && selected.label === "Scheduled for Appointment") {
      setflag(true); // Set flag to true if the selected value is "Scheduled for Appointment"
    } else {
      setflag(false); // Set flag to false otherwise
    }
  };
  // END

  // Competitor Name

  const handleSelectCompetitorName = (selection) => {
    const selected = selection;

    setSelectCompetitorName(selected);
  };

  useEffect(() => {
    const fetchCompetitor = async () => {
      try {
        const apiurl = process.env.REACT_APP_API_URL_1;
        const requestData = {
          Action: "getcompetitor",
          Authkey: "AdgT6SnjAkeLqlkE4",
          channelName: "FFA",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiurl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok for request 1");
        }

        const data = await response.json();
        // console.log("SourceDATA", data);
        setApiCompetitorData(data.Response); // Assuming responseData contains the state data
      } catch (error) {
        // console.error('Error fetching source:', error);
        // Handle errors
      }
    };

    fetchCompetitor();
  }, []);
  // END

  const handleSelectState = (selectedOption) => {
    const selected = selectedOption;
    // console.log("selected", selected.value);
    setSelectState(selected);
    setApiStateCode(selected.value);

    if (selected !== previousSelectedState) {
      fetchData();
      setPreviousSelectedState(selected);
    }
    setSelectCity("");
    setSelectArea("");
    setSelectSociety("");
  };
  const handleSelectCity = (selectedOption) => {
    const selected = selectedOption;
    // console.log("selected", selected);
    setSelectCity(selected);
    setApiCityCode(selected.value);
  };

  const handleSelectArea = (selectedOption) => {
    const selected = selectedOption;
    // console.log("selected",selected.value)
    setSelectArea(selected);
    setApiAreaCode(selected.value);
  };

  const handleSelectSociety = (selectedOption) => {
    // console.log("society", selectedOption);
    const selected = selectedOption;
    setSelectSociety(selected);
  };
  const handleMobileChange = (e) => {
    const mobileNumber = e.target.value;
    setmobileNo(mobileNumber);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const handleAlternateChange = (e) => {
    const alternativeNumber = e.target.value;
    setalternateNo(alternativeNumber);
  };
  //   const handleOtpChange = async (e) => {
  //     alert('ha')
  //     console.log("otpsend",e.target.value)
  //     if (!mobileNo) {
  //       toast.warning("Please Enter Customer Contact Number", {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         autoClose: 1500,
  //       });
  //     } else if (
  //       !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
  //     ) {
  //       toast.warning("Please Enter Customer Email Id", {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         autoClose: 1500,
  //       });
  //     } else {
  //       try {
  //         setIsLoading(true);
  //     const apiurl = process.env.REACT_APP_API_URL;
  //     const requestData = {
  //       Action: 'sendOTPContact',
  //       Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
  //       mobileNo: mobileNo,
  //       preOTP: "",
  //       userEmail: email
  //     };

  //     try {
  //       const response = await fetch(apiurl, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(requestData)
  //       });

  //       if (!response.ok) {
  //         throw new Error('Network response was not ok for request 1');
  //       }

  //       const responseData = await response.json();
  //       console.log("responseData1", responseData.Response);
  //       if (responseData.Status === "Success") {
  //         // console.log("send otp :",sendOtpData.Status)
  //         toast.success("OTP Send Successfully", {
  //           position: toast.POSITION.BOTTOM_CENTER,
  //           autoClose: 1500,
  //         });
  //         setOtpValue(responseData.Response);

  //         setIsLoading(false);
  //         console.log("sendOtpData.Response :", responseData.Response);
  //       } else {
  //         // console.error('Failed to send OTP:', otpResponse.statusText);
  //         toast.warning(response.statusText, {
  //           position: toast.POSITION.BOTTOM_CENTER,
  //           autoClose: 1500,
  //         });
  //         setIsLoading(false);
  //       }

  //     } catch (error) {
  //       console.error('Error:', error);
  //       // Handle errors
  //     }
  //   };
  // }

  //   };

  const handleDateTime = (selected) => {
    // console.log("selected", selected._d);
    const formattedDateTime = moment(selected._d).format("DD-MM-YYYY HH:mm:ss");
    // console.log("selected", formattedDateTime);
    setSelectDateTime(selected);
  };

  const handleOtpChange = async (e) => {
    // alert('ha');
    // console.log("otpsend", e.target.value);

    if (!mobileNo) {
      toast.warning("Please Enter Valid Mobile Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // } else if (mobileNo != 10){
      //   toast.warning("Please Enter Valid Mobile Number", {
      //     position: toast.POSITION.BOTTOM_CENTER,
      //     autoClose: 1500,
      //   });
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      toast.warning("Please Enter Customer Email Id", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else {
      try {
        setIsLoading(true);
        const apiurl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "sendOTPContact",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          mobileNo: mobileNo,
          preOTP: "",
          userEmail: email,
        };

        const response = await fetch(apiurl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok for request 1");
        }

        const responseData = await response.json();
        // console.log("responseData1", responseData.Response);

        if (responseData.Status === "Success") {
          toast.success("OTP Send Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          setOtpValue(responseData.Response);
          setIsLoading(false);
          setResendOtp(true);
          // console.log("sendOtpData.Response :", responseData.Response);
        } else {
          toast.warning(response.statusText, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          setIsLoading(false);
          setResendOtp(true);
        }
      } catch (error) {
        console.error("Error:", error);
        // Handle errors
      }
    }
  };

  const handleResendOtpChange = async () => {
    // alert("ha");
    // console.log("otpsend");
    const sendotpValue = String(otpvalue).trim();

    try {
      setIsLoading(true);
      const apiurl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "sendOTPContact",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        mobileNo: mobileNo,
        preOTP: sendotpValue,
        userEmail: email,
      };

      const otpResponse = await fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!otpResponse.ok) {
        throw new Error("Network response was not ok for request 1");
      }

      const responseResendData = await otpResponse.json();
      // console.log("responseData1", responseResendData.Response);

      if (responseResendData.Status === "Success") {
        toast.success("OTP ReSend Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        // setOtpValue(responseResendData.Response);
        setIsLoading(false);
        // console.log("sendOtpData.Response :", responseResendData.Response);
      } else {
        toast.warning(otpResponse.statusText || "Failed to send OTP", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle errors
    }
  };

  const handleOtp = (e) => {
    const enteredOtp = e.target.value;
    setInputOtp(enteredOtp);
  };

  const handleOtpVerification = (e) => {
    // console.log("inputOtp", inputOtp);
    // console.log("otpvalue", otpvalue);

    // Trim inputOtp and otpvalue to remove any leading or trailing whitespace
    const trimmedInputOtp = inputOtp.trim();
    const trimmedOtpvalue = String(otpvalue).trim();
    setIsLoading(true);
    if (trimmedInputOtp === trimmedOtpvalue) {
      toast.success("OTP verified Successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      setIsLoading(false);
      setOTPContactStatus("111260000");
    } else {
      toast.warning("Incorrect OTP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      setOTPContactStatus("111260001");
      setIsLoading(false);
    }
  };

  // const handleSubmit = async () => {
  //   console.log("selectDateTime",selectPlanCategory)
  //       console.log("selectDateTime",selectStatus)
  //       const statusMap = {
  //               'Closed': '111260001',
  //               'Scheduled for Appointment': '111260000',
  //               'Lead Created/Closed': '111260002'
  //             };

  //             const status = statusMap[selectStatus.label] || null;
  //             const planCategoryMap = {
  //               'BBB': 'BBB',
  //               'OBB': 'OBB'
  //             };

  //             const planCategory = planCategoryMap[selectPlanCategory.value] || null;
  //             console.log("selectDateTime",planCategory)
  //             console.log("selectDateTime",status)
  // }

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      if (!fullName) {
        toast.warning("Please Enter Full Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } 
      // else if (!lastName) {
      //   toast.warning("Please Enter Last Name", {
      //     position: toast.POSITION.BOTTOM_CENTER,
      //     autoClose: 1500,
      //   });
      //   setIsLoading(false); // Set loading state to false
      //   return;
      // }
       else if (!mobileNo) {
        toast.warning("Please Enter  Mobile Number", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (mobileNo.length !== 10) {
        toast.warning("Please Enter Valid  Mobile Number", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        toast.warning("Please Enter a Valid Email Id", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      }
      // else if (!selectSource) {
      //   toast.warning("Please Enter  Source", {
      //     position: toast.POSITION.BOTTOM_CENTER,
      //     autoClose: 1500,
      //   });
      //   setIsLoading(false); // Set loading state to false
      //   return;
      // }
      else if (!selectPlanCategory) {
        toast.warning("Please select  Plan Category", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!selectStatus) {
        toast.warning("Please Enter Status Reason", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!selectCompetitorName) {
        toast.warning("Please select  competitor", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!selectState) {
        toast.warning("Please select  state", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!selectCity) {
        toast.warning("Please select  city", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!selectArea) {
        toast.warning("Please select  area", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!selectSociety) {
        toast.warning("Please select  society", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      } else if (!remarks) {
        toast.warning("Please fill remarks", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false); // Set loading state to false
        return;
      }

      const apiurl = process.env.REACT_APP_API_URL;
      const areaValue = selectArea.value;
      const stateValue = selectState.value;
      const cityValue = selectCity.value;
      const societyValue = selectSociety.value;
      const competitiorName = selectCompetitorName.value;
      const source = selectSource.value;
      // console.log("selectDateTime", selectDateTime);
      // console.log("selectDateTime", selectPlanCategory);
      // console.log("selectDateTime", selectStatus);

      const fullname = fullName.trim(); // Get full name
    const words = fullname.split(" "); // Split into words
    const midIndex = Math.ceil(words.length / 2);

    const firstName = words.slice(0, midIndex).join(" ");
    const lastName = words.slice(midIndex).join(" ");


    // console.log("First Half:", firstName);
    // console.log("Second Half:", lastName);

      const statusMap = {
        Closed: "111260001",
        "Scheduled for Appointment": "111260000",
        "Lead Created/Closed": "111260002",
      };

      const status = statusMap[selectStatus.label] || null;
      const planCategoryMap = {
        BBB: "BBB",
        OBB: "OBB",
      };

      const planCategory = planCategoryMap[selectPlanCategory.value] || null;
      const requestData = {
        Action: "createContact",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        area: areaValue,
        building: "",
        businessSegment: "Home",
        callAttempted: "1",
        campaignName: "",
        channel: selectLeadChannel.value ? selectLeadChannel.value : "", 
        city: cityValue,
        competitorName: competitiorName,
        contactId: "",
        contactVerificationStatus: OTPContactStatus,
        disposition: "111260001",
        dncNumber: "",
        emailAddress: email,
        firstName: firstName,
        followupDate: selectDateTime,
        lastName: lastName,
        mobileNumber: mobileNo,
        mobileNumber2: alternateNo,
        password: sessionStorage.getItem("password"),
        planCategory: planCategory,
        remark: remarks,
        society: societyValue,
        source: selectLeadSource.value ? selectLeadSource.value : "",
        specifyArea: "",
        specifybuilding: "",
        state: stateValue,
        statusReason: status,
        userName: sessionStorage.getItem("userName"),
      };

      const Response = await fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!Response.ok) {
        throw new Error("Network response was not ok for request 1");
      }

      const submitData = await Response.json();
      // console.log("responseData1", submitData.Response);
      const lead = submitData.Response.Lead;
      // console.log("requestData:", requestData);
      if (submitData.Status === "Success") {
        if (status === "111260002") {
          // Lead Created/Closed
          toast.success("Lead Created  Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          setIsLoading(false);
          // navigate(`/broadbandLeadForm?LeadId=${lead}`);
          navigate("/broadbandLead");
        } else {
          toast.success("Contact Details Submitted Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          navigate("/broadbandContactManage");
        }
      } else {
        toast.warning("Failed to send Data", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle errors
    }finally{
      setIsLoading(false);
    }
  };

  //  const handleIconClick = (formId) => {
  //   if (activeForm !== formId) {
  //     setActiveForm(formId);
  //   }
  //   };
  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  // STATE,CITY,AREA,SOCIETY API
  const fetchData = async () => {
    try {
      // First API request
      const url1 = process.env.REACT_APP_API_URL_2;
      const requestData1 = {
        Action: "getSpecState",
        Authkey: "AdgT6SnjAkeLqlkE4",
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response1 = await fetch(url1, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData1),
      });

      if (!response1.ok) {
        throw new Error("Network response was not ok for request 1");
      }

      const responseData1 = await response1.json();
      // console.log("responseData1", responseData1.Response);
      setOptionState(responseData1.Response);

      // Second API request
      const url2 = process.env.REACT_APP_API_URL_2;
      const requestData2 = {
        Action: "getcity",
        Authkey: "AdgT6SnjAkeLqlkE4",
        stateCode: apiStateCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response2 = await fetch(url2, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData2),
      });

      if (!response2.ok) {
        throw new Error("Network response was not ok for request 2");
      }

      const responseData2 = await response2.json();
      // console.log("responseData2", responseData2.Response[0]);
      setOptionCity(responseData2.Response);

      // Third API request
      const url3 = process.env.REACT_APP_API_URL_2;
      const requestData3 = {
        Action: "getarea",
        Authkey: "AdgT6SnjAkeLqlkE4",
        cityCode: apiCityCode,
        cityName: selectCity,
        restrictedarea: true,
        stateCode: "",
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response3 = await fetch(url3, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData3),
      });

      if (!response3.ok) {
        throw new Error("Network response was not ok for request 3");
      }

      const responseData3 = await response3.json();
      // console.log("responseData3", responseData3.Response);
      setOptionArea(responseData3.Response);

      // Fourth API request
      const url4 = process.env.REACT_APP_API_URL_2;
      const requestData4 = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: apiAreaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response4 = await fetch(url4, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData4),
      });

      if (!response4.ok) {
        throw new Error("Network response was not ok for request 4");
      }

      const responseData4 = await response4.json();
      // console.log("responseData4", responseData4.Response);
      // setOptionSociety(responseData4.Response);
      if (responseData4.Status === "Failure" && apiAreaCode !== "") {
        toast.warning(responseData4.statusText || "Society is not Mapped", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false);
      } else {
        // console.log("responseData4", responseData4.Response);
        setOptionSociety(responseData4.Response);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchData();
  }, [apiStateCode, apiCityCode, apiAreaCode]);

  // END

  const navigate = useNavigate();
  const redirectContactManagement = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/broadbandContactManage");
      } else {
        navigate("/broadbandContactsForm");
      }
    });
  };

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectContactManagement}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Contact Management</span>
        </div>
      </div>
      {/* ************Header end************ */}
      <div>
        {isLoading && (
          <div className="loader-wrapper">
            <div className="loader">
              <img src={loader} alt="loading...."></img>
            </div>
          </div>
        )}
        <div className="container-fluid form-container">
          {/* **************Contact Information toggle******************* */}
          <div
            className="contact-toggle"
            onClick={() => handleIconClick("form1")}
          >
            <span className="toggle-text">Contact Information</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form1" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form1"
            >
              {/* *********Contact Information form******** */}
              <form className=" contact-form p-2" onSubmit={handleSubmit}>

              <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={fullName}
                    onChange={handleFullName}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Full Name*</label>
                </div>

                {/* <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    onChange={handleFirst}
                  />
                  <label htmlFor="floatingInput" className="mt-2">First Name*</label>
                </div>
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="lastName"
                    name="lastName"
                    value={lastName}
                    onChange={handleLast}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Last Name*</label>
                </div> */}

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="mobile"
                    name="mobile"
                    value={mobileNo}
                    maxLength="10"
                    pattern="[0-9]{10}"
                    onChange={handleMobileChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (mobileNo.length < 10 || e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                    disabled={OTPContactStatus === "111260000"} // Disable if OTP is verified
                  />
                  <label htmlFor="floatingInput" className="mt-2">Mobile Number*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id=""
                    name=""
                    value={alternateNo}
                    onChange={handleAlternateChange}
                    maxLength="10"
                    pattern="[0-9]{10}"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (alternateNo.length < 10 || e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Alternate Number</label>
                </div>
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="email"
                    name="email"
                    value={email}
                    onChange={handleEmailChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Email ID*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="businessSegment"
                    name="businessSegment"
                    value="Home"
                    disabled
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Business Segment*</label>
                </div>


                <div className="select-container mt-2">
                  <label className="select-search-label">Channel*</label>
                  <Select
                    className=" basic-single form-control form-control-sm  p-1"
                    classNamePrefix="select"
                    name="leadChannel"
                    placeholder="Select"
                    styles={style}
                    value={selectLeadChannel}
                    isSearchable={false}
                    onChange={handleSelectChannel}
                    // isDisabled={
                    //   ContactId && checkStatusReason == "Lead Created/Closed"
                    // }
                    options={optionLeadChannel.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Source*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="leadSource"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable={true}
                    value={selectLeadSource}
                    // isDisabled={
                    //   ContactId && checkStatusReason == "Lead Created/Closed"
                    // }
                    onChange={handleSelectLeadSource}
                    options={leadSourceOptions}
                  />
                </div>

                {/* {selectLeadSource && selectLeadSource?.label?.includes("Other") ? (
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="specifyLeadSource"
                  name="specifyLeadSource"
                  value={specifyLeadSource}
                  style={{ background: "transparent" }}
                  onChange={handleSpecifyLeadSource}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Specify Lead Source
                </label>
              </div>) : null} */}

                {/* <div className="">
                  <label className="select-search-label mt-1">Source*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    id="source"
                    name="source"
                    placeholder="Select Option"
                    styles={style}
                    value={selectSource}
                    isSearchable={false}
                    onChange={handleSelectSource}
                    options={apiSourceData?.map((data) => ({
                      value: data.SourceName,
                      label: data.SourceName,
                    }))}
                  />
                </div> */}

                <div className="">
                  <label className="select-search-label mt-1">
                    Plan Category*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    id="planCategory"
                    name="planCategory"
                    placeholder="Select Option"
                    styles={style}
                    value={selectPlanCategory}
                    isSearchable={false}
                    onChange={handleSelectPlanCategory}
                    options={optionPlanCategory}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Status Reason*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    id="status"
                    name="status"
                    placeholder="Select Option"
                    styles={style}
                    value={selectStatus}
                    isSearchable={false}
                    onChange={handleSelectStatus}
                    options={optionStatusReason}
                  />
                </div>
                {flag && (
                  <div className="">
                    <label className="select-search-label mt-1">
                      Follow Up-Date*
                    </label>
                    <DateTime
                      locale="en"
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Date"
                      id="dateTime"
                      name="dateTime"
                      styles={style}
                      value={selectDateTime}
                      onChange={handleDateTime}
                      dateFormat="DD/MM/YYYY"
                    />
                  </div>
                )}

                <div className="">
                  <label className="select-search-label mt-1">
                    Competitor Name*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    placeholder="Select Option"
                    id="CompetitorName"
                    styles={style}
                    name="CompetitorName"
                    value={selectCompetitorName}
                    onChange={handleSelectCompetitorName}
                    options={apiCompetitorData.map((option) => ({
                      value: option.CompetitorName,
                      label: option.CompetitorName,
                    }))}
                  />
                </div>

                {OTPContactStatus !== "111260000" && (
                  <div className="input-box form-floating ">
                    <input
                      type="tel"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="otp"
                      name="otp"
                      value={inputOtp}
                      onChange={handleOtp}
                      maxLength="6"
                      pattern="[0-9]{10}"
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        const inputOtpLength = inputOtp ? inputOtp.length : 0;
                        if (
                          (isDigit || allowedKeys.includes(e.key)) &&
                          (inputOtpLength < 6 || e.key === "Backspace")
                        ) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      OTP
                    </label>
                  </div>
                )}
              </form>
            </div>
          )}

          {/* **************Installation Address toggle******************* */}
          <div
            className="Installation-toggle mt-3"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">Installation Address</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form2" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form2"
            >
              {/**********Installation Address form******** */}
              <form className="Installation-form p-2">
                <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="state"
                    placeholder="Select Option"
                    isSearchable
                    styles={style}
                    value={selectState}
                    onChange={handleSelectState}
                    options={optionState.map((data) => ({
                      label: `${data.StateName} (${data.StateCode})`,
                      value: data.StateCode,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">City*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="City"
                    placeholder="Select Option"
                    isSearchable
                    styles={style}
                    value={selectCity}
                    onChange={handleSelectCity}
                    options={optionCity.map((data) => ({
                      value: data.CityCode,
                      label: data.CityName,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Area*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable
                    value={selectArea}
                    onChange={handleSelectArea}
                    options={optionArea.map((area) => ({
                      value: area.AreaCode,
                      label: `${area.AreaName} (${area.AreaCode})`,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Society*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    placeholder="Select Option"
                    styles={style}
                    isSearchable
                    value={selectSociety}
                    onChange={handleSelectSociety}
                    options={(optionSociety || []).map((data) => ({
                      value: data.SocietyCode,
                      label: `${data.SocietyName} (${data.SocietyCode})`,
                    }))}
                  />
                </div>
              </form>
            </div>
          )}

          {/* **************Remarks toggle******************* */}
          <div
            className="Installation-toggle mt-3"
            onClick={() => handleIconClick("form3")}
          >
            <span className="toggle-text">Remarks</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form3" && (
            <div
              className=" container shadow  mb-3 bg-body rounded mt-4"
              id="form3"
            >
              <form className="Remark-form p-2">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="remark"
                    name="remark"
                    value={remarks}
                    onChange={handleRemark}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Remarks*</label>
                </div>
              </form>
            </div>
          )}
         

          {!inputOtp && mobileNo && !resendotp && (
            <div className="text-center mt-5 mb-3">
              <button
                type="submit"
                className="btn rounded-pill text-light submit-btn bg-dark mx-auto"
                onClick={handleOtpChange}
              >
                Send OTP
              </button>
            </div>
          )}

          {resendotp && (
            <div className="row">
              <div className="col-6">
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn  text-light rounded-pill btn-verify_otp bg-dark mx-auto"
                    onClick={handleResendOtpChange}
                    hidden={OTPContactStatus === "111260000"}
                  >
                    Resend OTP
                  </button>
                </div>
              </div>
              <div className="col-6">
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn  text-light rounded-pill submit-btn bg-dark mx-auto btn-resend_otp"
                    onClick={handleOtpVerification}
                    hidden={OTPContactStatus === "111260000"}
                  >
                    Submit OTP
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className=" text-center mt-5 mb-3">
            <button
              type="submit"
              className="btn rounded-pill text-light submit-btn bg-dark mx-auto"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BroadbandContactsManageForm;
